import Dropcursor from '@tiptap/extension-dropcursor';
import Gapcursor from '@tiptap/extension-gapcursor';
import HardBreak from '@tiptap/extension-hard-break';
import History from '@tiptap/extension-history';
import { Table, TableRow, TableCell } from '../extension-word-table';
import Text from '@tiptap/extension-text';
import TextAlign from '@tiptap/extension-text-align';
import {
    WordBold,
    WordItalic,
    WordUnderline,
    WordStrike,
    WordSubscript,
    WordSuperscript,
    LineSpacing,
    WordBody,
    WordBookmarkNode,
    WordBulletList,
    WordDocument,
    WordExtras,
    WordHeaderFooter,
    WordHyperlinkNode,
    WordImage,
    WordListItem,
    WordNumberingList,
    WordOrderedList,
    WordPageNumber,
    WordParagraph,
    WordSection,
    WordToc,
    WordUniqueId,
    WordTextStyle,
    WordFontFamily,
    WordColor,
} from '.';
import { createCommentMarkInstance } from '../extension-comment/Comment';
// import StarterKit from '@tiptap/starter-kit';
import WordPageBreak from '../extension-page-break';
import WordIndent from '../extension-word-indent';
import { DeletedText, InsertedText } from '../extension/Diff';
import { createHighlightExtensionInstance } from '../extension/Highlight';
import { createClauseBadgeExtensionInstance } from '../extension/ClauseBadgeExtension';
import TabKeyPrevent from '../extension/TabKeyPrevent';
import { InvisibleCharacters } from '../extension/InvisibleCharacters';

export const wordStarterPackExtensions = [
    TabKeyPrevent,
    WordDocument,
    WordSection,
    WordBody,
    WordHeaderFooter,
    WordPageBreak,
    WordParagraph.configure({
        HTMLAttributes: {
            class: 'm-0 min-h-[1em] whitespace-pre-wrap',
        },
    }),
    Dropcursor,
    Gapcursor,
    History,
    Text,
    WordTextStyle,
    WordFontFamily,
    WordColor,
    WordBold,
    WordItalic,
    WordStrike.extend({
        parseHTML() {
            return [
                {
                    tag: 's',
                },
                {
                    tag: 'strike',
                },
                {
                    style: 'text-decoration',
                    consuming: false,
                    getAttrs: style => ((style as string).includes('line-through') ? {} : false),
                },
            ];
        },
    }),
    WordUnderline,
    WordSubscript,
    WordSuperscript,
    // Code,
    TextAlign.configure({
        types: ['heading', 'paragraph', 'bulletList', 'orderedList'],
    }),
    Table,
    TableRow,
    TableCell,
    WordBulletList,
    WordOrderedList,
    WordListItem,
    WordNumberingList,
    LineSpacing,
    WordIndent,
    HardBreak,
    InsertedText.configure({
        HTMLAttributes: {
            class: 'bg-blue-200 text-blue-700 no-underline p-1',
        },
    }),
    DeletedText.configure({
        HTMLAttributes: {
            class: 'bg-red-200 text-red-700 line-through p-1',
        },
    }),
    createCommentMarkInstance().configure({
        HTMLAttributes: {
            class: 'word-comment',
        },
        onCommentActivated: commentId => {
            // console.log('commentId', commentId);
        },
    }),
    // HighlightExtension,
    createHighlightExtensionInstance(),
    WordToc,
    WordHyperlinkNode,
    WordBookmarkNode,
    WordExtras,
    WordPageNumber,
    WordImage,
    WordUniqueId,
    InvisibleCharacters,
    // ClauseBadgeExtension,
    createClauseBadgeExtensionInstance(),
];
